import React, {useState, useEffect} from 'react';
import Grid from '@material-ui/core/Grid';
import Header from './Header'
import Paper from '@material-ui/core/Paper';
import { makeStyles } from '@material-ui/core/styles';
import useStore from './store' 
import Typography from '@material-ui/core/Typography';
import _ from 'lodash'
import {CustomSelect, CustomInput, CustomDatePicker} from './Component'
import Button from '@material-ui/core/Button';
import Swal from 'sweetalert2';
import {doPost} from './AjaxRequests'
import { useHistory, Link } from "react-router-dom";
import queryString from 'query-string'


const useStyles = makeStyles(theme => ({    
  paper:{
      padding: theme.spacing(3),
      backgroundColor: theme.palette.paper.white,        
  },  
  subTitle:{
      color: theme.palette.text.white,
      fontSize:"18px" 
  },
    btn__wrapper:{
        width:"100%",
        display:"flex",
        alignContent:"center",
        justifyContent:"center",
        padding:theme.spacing(3,0)
    }  
}));

function Page1(props) {
    const history = useHistory();

    const classes = useStyles(props);
    const store = useStore()       

    const setGerneralInfo = (field, value) =>{              
        let payload = {}
        if(field.includes("idno")){
          payload[field] = value.toUpperCase()
        }else{
          payload[field] = value   
        }

        if(field == "reason" && value=="VIS"){
            payload['idno'] = ""
        }

        if(field == "reason" && value!="VIS"){
            payload['auth_code'] = ""
        }
            
        store.setGeneralInfo({...store.gerneralInfo, ...payload})    
    }

    const [submiting, setSubmiting] = useState(false)

    const [EMP2, setEMP2] = useState(false)

    useEffect(()=>{
      const parsed = queryString.parse(props.location.search);  
      if(parsed.EMP2){
        if(parsed.EMP2=="Y"){
          setEMP2(true)
          setGerneralInfo("reason", "EMP2")
        }
      }

      
        // const payload = {
           
        // }
        // store.setGeneralInfo({...store.gerneralInfo, ...payload})

        if(window.localStorage){ 
            let localStorage = window.localStorage
            const pData = localStorage.pData
            // let info = {
            //     apply_user_idno:store.login.idno,
            //     apply_user_phone: store.login.phone
            // }

            let info = {}

            if(pData){
                        
              doPost(`https://www.kfsyscc.org/normal_api/service`, {
                  "api": "aesdecode",
                  "str": pData
              })       
              .then((data)=>{   
                    
                  if(data.data.status === 200){
                      let result = JSON.parse(data.data.data.result)
                      if(result.apply_user_name){
                          info.apply_user_name = result.apply_user_name
                      }
                      if(result.apply_user_mail){
                          info.apply_user_mail = result.apply_user_mail
                      }
                      if(result.apply_user_birthday){
                          info.apply_user_birthday = result.apply_user_birthday
                      }


                      // if(result.idno){
                      //     info.idno = result.idno
                      // }                     
                  }

                if(store.login.idno ){                  
                    info.apply_user_idno = store.login.idno               
                }
    
                if( store.login.phone ){
                    info.apply_user_phone = store.login.phone               
                }
    
                if( store.login.name){
                  info.apply_user_name = store.login.name               
                }
    
              if( store.login.birthday){
                  info.apply_user_birthday = store.login.birthday               
                }
    
                store.setGeneralInfo({...store.gerneralInfo, ...info})
           
                  // store.setGeneralInfo({...store.gerneralInfo, ...info}) 
                  
              })
              .catch(()=>{
                  store.setGeneralInfo({...store.gerneralInfo, ...info})
              
              })
          }else{
            
            if(store.login.idno ){                  
              info.apply_user_idno = store.login.idno               
          }

          if( store.login.phone ){
              info.apply_user_phone = store.login.phone               
          }

          if( store.login.name){
            info.apply_user_name = store.login.name               
          }

        if( store.login.birthday){
            info.apply_user_birthday = store.login.birthday               
          }
              store.setGeneralInfo({...store.gerneralInfo, ...info})
          }


            

        }
    

    },[])

    const handleSubmit = () =>{
        setSubmiting(true)

        if(!store.gerneralInfo.apply_user_birthday){
          Swal.fire("請填寫申請人生日", "", "warning")
          setSubmiting(false)
          return
        }

        if(!store.gerneralInfo.apply_user_phone){
          Swal.fire("請填寫申請人手機", "", "warning")
          setSubmiting(false)
          return
        }

        

        let payload = 
          {
            "api": "CheckDoorAccessApply",
            "reg_date":store.gerneralInfo.reg_date,         
            "apply_user_idno":store.gerneralInfo.apply_user_idno, 
            "apply_user_name":store.gerneralInfo.apply_user_name,  
            "apply_user_birthday":store.gerneralInfo.apply_user_birthday, 
            "apply_user_mail":store.gerneralInfo.apply_user_mail,
            "apply_user_phone":store.gerneralInfo.apply_user_phone, 
            "idno": store.gerneralInfo.idno,                       
            "reason":store.gerneralInfo.reason,   
            "auth_code": store.gerneralInfo.auth_code,                                 
            "cre_user_id":props.user===null?"PATIENT": props.user.USER_ID,
            "remark":store.gerneralInfo.remark,
            // "dept":store.gerneralInfo.dept          
          } 
          
        
          
        doPost('https://www.kfsyscc.org/normal_api/service', payload) 
        .then((data)=>{
             
            if(data.data.pass=="Y"){ 
              setGerneralInfo("isPass", data.data.pass)
              
              
            }else if(data.data.pass=="N"){
              setGerneralInfo("isPass", data.data.pass)
              throw Error(data.data.message)
            //   Swal.fire(data.data.message, "", "warning")
            }else{
              throw Error("連線錯誤")
            }      
                      
        })
        .then(()=>{
            if(window.localStorage){
                let pData = {
                    "apply_user_name":store.gerneralInfo.apply_user_name,   
                    "apply_user_mail":store.gerneralInfo.apply_user_mail,
                    "apply_user_birthday":store.gerneralInfo.apply_user_birthday,
                    "idno": store.gerneralInfo.idno 
                }
                return doPost(`https://www.kfsyscc.org/normal_api/service`, {
                        "api": "aesencode",
                        "str": JSON.stringify(pData)  
                    })
                    .then((data)=>{    
                        if(window.localStorage){
                            window.localStorage.pData = data.data.data.result
                        }                                         
                                   
                    })     
                
            } 
            setSubmiting(false)
        })
        .then(()=>{
            if(EMP2==true){
                history.push('/page2?EMP2=Y')
              }else{
                history.push('/page2')
              }
        })
        .catch((e)=>{
          setSubmiting(false) 
          Swal.fire(e.message, "", "error")
        })
        
    }

    const filterReason=(reasons)=>{
      const parsed = queryString.parse(props.location.search);  
     
        if(EMP2){
          return _.filter(reasons, (o)=>{return o.value=="EMP2"})
        }

      return _.filter(reasons, (o)=>{return o.value!="EMP2"})
    }

    useEffect(()=>{

        if(EMP2 || store.gerneralInfo.reason === "VIS" || store.gerneralInfo.reason === "REG"|| store.gerneralInfo.reason === "AE2" || store.gerneralInfo.reason === "REGE" || store.gerneralInfo.reason === "PHE"){

            setGerneralInfo("idno", "")
        }

    },[store.gerneralInfo.reason])
    
    

    return (        
      <Grid container spacing={3}>
        <Grid item xs={12}>
            <Header/>
        </Grid> 
        <Grid item xs={12}>
          <Typography 
              variant="h6"
              className={classes.subTitle}
          >
              基本資料
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Paper
            square                   
            className={classes.paper}
            elevation={3}
          >
            <Grid container spacing={2}>
            <CustomSelect
                width = {12}
                field = "reason"
                value = {store.gerneralInfo.reason}
                handleSelectChange = {setGerneralInfo}
                placeHolder = "申請通關原因" 
                options={filterReason(props.options.reason)}    
                // error={error.gerneralInfo.reason}           
              /> 
              <CustomDatePicker
                disabled
                width = {12}
                value = {store.gerneralInfo.reg_date}
                handleSelectChange = {setGerneralInfo}
                label = "申請通關日期"
                field = "reg_date"
                // disablePast
                minDate = {props.user==null?new Date():new Date(new Date().getTime()-(1000*60*60*24*30))}
                maxDate = {new Date(new Date().getTime())}
                // error = {error.gerneralInfo.reg_date}                
              />
              <CustomInput
                width = {12}
                field = "apply_user_idno"
                value = {store.gerneralInfo.apply_user_idno}
                handleSelectChange = {setGerneralInfo}
                placeHolder = "申請人身分證字號"                   
                // error = {error.gerneralInfo.apply_user_idno}                                       
              />
              <CustomInput
                width = {12}
                field = "apply_user_name"
                value = {store.gerneralInfo.apply_user_name}
                handleSelectChange = {setGerneralInfo}
                placeHolder = "申請人姓名"                   
                // error = {error.gerneralInfo.apply_user_name}                                       
              />
               <CustomDatePicker
                width = {12}
                value = {store.gerneralInfo.apply_user_birthday}
                handleSelectChange = {setGerneralInfo}
                label = "申請人生日"
                field = "apply_user_birthday"
                openTo = "year"
                // disablePast
                // minDate = {props.user==null?new Date():new Date(new Date().getTime()-(1000*60*60*24*30))}
                // maxDate = {new Date(new Date().getTime()+(1000*60*60*24*1))}
                // error = {error.gerneralInfo.reg_date}                
              />
              <CustomInput
                width = {12}
                field = "apply_user_mail"
                value = {store.gerneralInfo.apply_user_mail}
                handleSelectChange = {setGerneralInfo}
                placeHolder = "申請人E-mail"                   
                // error = {error.gerneralInfo.apply_user_mail}                                       
              />
              <CustomInput
                width = {12}
                field = "apply_user_phone"
                value = {store.gerneralInfo.apply_user_phone}
                handleSelectChange = {setGerneralInfo}
                placeHolder = "申請人手機"                   
                // error = {error.gerneralInfo.apply_user_phone}                                       
              />
              {EMP2 || (store.gerneralInfo.reason === "VIS" || store.gerneralInfo.reason === "REG"|| store.gerneralInfo.reason === "AE2" || store.gerneralInfo.reason === "PHE")?null:
              <CustomInput
                width = {12}
                field = "idno"
                value = {store.gerneralInfo.idno}
                handleSelectChange = {setGerneralInfo}
                placeHolder = {`${store.gerneralInfo.reason === "REGE"||store.gerneralInfo.reason === "AE"?"病人/健檢/疫苗施打者身份證號":"住院號碼"}`}                   
                // error = {error.gerneralInfo.idno}                                       
              />  
              }  
            {EMP2 || store.gerneralInfo.reason !== "VIS"?null:
              <CustomInput
                width = {12}
                field = "auth_code"
                value = {store.gerneralInfo.auth_code}
                handleSelectChange = {setGerneralInfo}
                placeHolder = "授權碼"                   
                // error = {error.gerneralInfo.auth_code}                                       
              />  
              }  
              {/* {EMP2?
              <CustomInput
                width = {12}
                field = "dept"
                value = {store.gerneralInfo.dept}
                handleSelectChange = {setGerneralInfo}
                placeHolder = "部門代碼"                   
                // error = {error.gerneralInfo.dept}                                       
              />:null
              }     */}
            <CustomInput
                width = {12}
                field = "remark"
                value = {store.gerneralInfo.remark}
                handleSelectChange = {setGerneralInfo}
                placeHolder = "補充說明"                   
                // error = {error.gerneralInfo.remark}                                       
              />
            </Grid>  
          </Paper>
        </Grid> 
        <Grid item xs={12}>   
        <div className={classes.btn__wrapper}>
            <Link to="/" style={{textDecoration:"none", margin:"0 20px"}}>
                <Button variant="contained" color="secondary">
                    重新查詢
                </Button> 
            </Link> 
            {submiting?null:
                <Button variant="contained" color="primary" onClick={handleSubmit} style={{margin:"0 20px"}}>
                    下一步
                </Button>
            }
              
        </div>            
        </Grid>        
      </Grid> 
    );
}


export default Page1
  